import React from 'react';
import { Card, Flex, Heading, Text, Badge } from '@aws-amplify/ui-react';

export default function CareNoteCard({ data }) {
  return (
    <Card marginTop={21} variation="elevated" maxWidth={600}>
      <Flex direction={'column'} gap={9}>
        <Heading level={3} children={data?.givenName} />
        <Flex>
          <Badge size="small">Date: {data?.createdAt}</Badge>
          <Badge size="small">Overall status: {data?.overallStatus}</Badge>
          {data?.careDate && (
            <Badge size="small">Date of Care: {data.careDate}</Badge>
          )}
        </Flex>
        <Flex></Flex>
      </Flex>
      <Flex direction={'column'} gap={1}>
        <Heading level={6} children="Visit Summary" />
        <Text>{data?.visitSummary}</Text>
      </Flex>
      <Flex direction={'column'} gap={1}>
        <Heading level={6} children="Health Status" />
        <Text>{data?.healthSummary}</Text>
      </Flex>
    </Card>
  );
}
